import { Components, Theme } from '@mui/material/styles';

export const listItemConfigs: Components<Theme>['MuiListItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,

      '> .MuiListItemIcon-root': {
        minWidth: 0,

        ':first-of-type': {
          marginRight: theme.spacing(2),
        },

        ':last-of-type': {
          marginLeft: theme.spacing(2),
        },
      },

      '.MuiListItemText-root': {
        margin: 0,
      },
    }),
  },
};
